import React from "react";

type AuthHeaderProps = {
    showWelcome?: boolean;
};

const AuthHeader: React.FC<AuthHeaderProps> = ({ showWelcome = false }) => {
    return (
        <div className="self-stretch h-36 flex-col justify-start items-center gap-6 flex" id="title">
            <div className="justify-start items-start inline-flex">
                <img className="w-12 h-12" src="/icons/icon.png" alt="Karuna Logo"/>
            </div>
            <div className="self-stretch h-20 flex-col justify-start items-start gap-3 flex lg:h-40">
                <div className="self-stretch text-center text-gray-900 text-3xl font-semibold leading-9">Provider Portal</div>
                {
                    showWelcome && (
                        <div className="self-stretch text-center text-gray-600 text-base font-normal leading-normal">
                            Welcome back! Please enter your details.
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default AuthHeader;
